/* eslint-disable @typescript-eslint/ban-types */
import React from "react";
import { Button } from "../../Common/UI/Index";
import { ButtonVariantType } from "../../Common/UI/Types";
import Delete from "~icons/ic/outline-delete-outline";
import Edit from "~icons/ic/outline-edit";
import Download from "~icons/ic/outline-download";
import "./Style.scss";

interface IProps {
  /**
   * Event to be triggered on clicking the edit button
   */
  onEditClick: () => void;
  /**
   * Flag value to disable or enable the edit button
   */
  disabledEditButton: boolean;
  /**
   * Event to be triggered on clicking the delete icon
   */
  onDeleteIconClick: () => void;
  /**
   * Translate object to display labels
   */
  translate: Function;
  /**
   * To show/hide export dialog
   */
  handleExportDialogOpen: () => void;
}

/**
 * Returns the ribbon menus
 */
export const CustomizedRibbonMenus = (props: IProps): JSX.Element => {
  const {
    onEditClick,
    disabledEditButton,
    translate,
    onDeleteIconClick,
    handleExportDialogOpen
  } = props;
  const getIsArtefactsFound = sessionStorage.getItem("isArtefactsFound");
  const isArtefactsFound = getIsArtefactsFound === "true";

  return (
    <div className="ebt-extract-detail-ribbon-menu">
      <Button
        variant={ButtonVariantType.FILLED}
        data-testid="ebt-edit"
        onClick={onEditClick}
        disabled={disabledEditButton}
        className="ebt-extract-detail-edit-button"
      >
        <Edit title="edit" />
        {translate("Button.Edit")}
      </Button>
      <Button
        borderless={true}
        data-testid="ebt-delete"
        onClick={onDeleteIconClick}
        className="ebt-extract-detail-delete-button"
      >
        <Delete title="delete" />
        {translate("Button.Delete")}
      </Button>
      <Button
        data-testid="fsa-export"
        className="fsa-feasibility-detail-export-button"
        onClick={handleExportDialogOpen}
        disabled={!isArtefactsFound}
      >
        <Download title="export" />
        {translate("Button.ExportAssessment")}
      </Button>
    </div>
  );
};

